export default __webpack_public_path__ + "static/media/wwf_cube@2x.e70acfd9.jpg";